import { render } from "./ByCategory.vue?vue&type=template&id=919d10f2"
import script from "./ByCategory.vue?vue&type=script&lang=js"
export * from "./ByCategory.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/works/main/HelpDesk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__